<template>
  <div class="landing-page">
    <p class="level-2">落地页</p>
    <div class="content">
      <template v-if="havePorduct">
        <img
          class="left-cover"
          src="@/assets/images/simulation/pageCover.jpeg"
        />
        <div class="page-right-section">
          <div class="page-url">
            <el-popover placement="top" trigger="hover">
              <p style="font-size: 12px">系统根据当前商品自动生成的落地页</p>
              <span class="autoGen" slot="reference">系统生成</span>
            </el-popover>
            <span class="landing-page-link"
              >2021新款秋季长袖T恤男卫衣男士圆领套头爆款</span
            >
            <el-image
              class="icon"
              :src="require('@/assets/images/simulation/icon_link.png')"
              fit="cover"
            ></el-image>
          </div>
          <p class="page-id">ID: 3533542321478359295</p>
        </div>
      </template>
      <p class="empty-text" v-else>
        落地页需关联商品，<span @click="backTop">请先添加商品</span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    havePorduct: Boolean,
  },
  methods: {
    backTop() {
      this.$emit("backTop");
    },
  },
};
</script>

<style lang="less" scoped>
.landing-page {
  .level-2 {
    margin-top: 28px;
    margin-bottom: 12px;
    line-height: 20px;
    font-weight: 600;
    font-size: 14px;
    color: #333;
  }
  .content {
    padding: 16px;
    width: 416px;
    height: 76px;
    background: #f2f2f2;
    border-radius: 4px;
    .left-cover {
      width: 32px;
      height: 44px;
      object-fit: cover;
      object-position: top;
      border-radius: 2px;
    }
    .page-right-section {
      display: inline-block;
      margin-left: 10px;
      vertical-align: top;
      .page-url {
        .autoGen {
          display: inline-block;
          margin-right: 4px;
          padding: 0 4px;
          width: 60px;
          height: 20px;
          text-align: center;
          background: #edf0fd;
          border-radius: 2px;
          color: #194ce5;
          font-size: 12px;
          line-height: 20px;
          cursor: pointer;
        }
        .landing-page-link {
          display: inline-block;
          font-size: 14px;
          line-height: 20px;
          max-width: 260px;
          color: #333;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          vertical-align: middle;
          cursor: pointer;
          &:hover {
            color: #194ce5;
          }
        }
        .icon {
          margin-left: 3px;
          vertical-align: middle;
          cursor: pointer;
        }
      }
      .page-id {
        font-size: 12px;
        line-height: 20px;
        color: #999;
      }
    }
    .empty-text {
      margin-top: 10px;
      text-align: center;
      font-size: 14px;
      line-height: 22px;
      color: #999;
      span {
        color: #194ce5;
        cursor: pointer;
      }
    }
  }
}
</style>